const ClassNames = {
  BASE: 'tn-events-calendar',
  // TABLE_HEADING: 'tn-events-calendar__table-heading',
};

export default ClassNames;



// WEBPACK FOOTER //
// ./V7/events/listing/calendarView/html/ClassNames.js